import * as React from "react";

import type { JSX } from "react/jsx-runtime";

const WorkIconOrange = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M10.5 4.875V3.375H7.5V4.875H10.5ZM3 7.125V13.875C3 14.2875 3.3375 14.625 3.75 14.625H14.25C14.6625 14.625 15 14.2875 15 13.875V7.125C15 6.7125 14.6625 6.375 14.25 6.375H3.75C3.3375 6.375 3 6.7125 3 7.125ZM15 4.875C15.8325 4.875 16.5 5.5425 16.5 6.375V14.625C16.5 15.4575 15.8325 16.125 15 16.125H3C2.1675 16.125 1.5 15.4575 1.5 14.625L1.5075 6.375C1.5075 5.5425 2.1675 4.875 3 4.875H6V3.375C6 2.5425 6.6675 1.875 7.5 1.875H10.5C11.3325 1.875 12 2.5425 12 3.375V4.875H15Z"
      fill="#FF9933"
    />
  </svg>
);

export default WorkIconOrange;
